export enum StoreFinderTableType {
  Normal = 'normal',
  StoreFinder = 'store finder'
}

export enum StoreFinderTableColumnType {
  Text = 'text',
  Boolean = 'boolean',
  StoreFinder = 'store finder', // This i think is missnamed. I think it should say FMS?
  GoogleLocation = 'google location',
  CountryCode = 'country code'
}

export interface StoreFinderTableColumn {
  id: string
  dataKey: string
  columnHeading: string
  variableName: string
  variableId: string
  searchable: boolean
  type: StoreFinderTableColumnType
}

export interface StoreFinderTable {
  id: string
  botId: string
  createdAt: Date
  updatedAt: Date
  name: string
  type: StoreFinderTableType
  columns: StoreFinderTableColumn[]
  rows: unknown[]
}

/*
THESE ARE REDUNDANT AND CAN BE REPLACED ONCE FUTURE IS LAUNCHED 

*/

export enum LookupTableType {
  Normal = 'normal',
  StoreFinder = 'store finder'
}

export enum LookupTableColumnType {
  Text = 'text',
  Boolean = 'boolean',
  StoreFinder = 'store finder',
  GoogleLocation = 'google location'
}

export interface LookupTableColumn {
  id: string
  dataKey: string
  columnHeading: string
  variableName: string
  variableId: string
  searchable: boolean
  type: LookupTableColumnType
}

export interface LookupTable {
  id: string
  botId: string
  createdAt: Date
  updatedAt: Date
  name: string
  type: LookupTableType
  columns: LookupTableColumn[]
  rows: unknown[]
}
